import { ScanLine, PenTool, Printer, Truck, ArrowRight } from "lucide-react";

// HERO + 4-step infographic. Purely presentational — no state, no props.
// Extracted from Workflow.jsx so the orchestrator page stays focused on
// the form / state machinery, while the marketing-style top of the page
// can be lazy-evaluated separately.
const STEPS = [
    { n: "01", t: "Scan", d: "Upload your intraoral scans (STL / PLY / OBJ / DCM) from any major scanner.", icon: ScanLine },
    { n: "02", t: "Design", d: "Our clinical technicians precision-design your restoration in exocad.", icon: PenTool },
    { n: "03", t: "Print & Cure", d: "Fabricated using industry-leading resin 3D printers, post-cured to full strength.", icon: Printer },
    { n: "04", t: "Deliver", d: "Same-day dispatch directly to your clinic. Doha-wide and across the Gulf.", icon: Truck },
];

export function WorkflowHero() {
    return (
        <>
            {/* HERO */}
            <section className="border-b border-slate-200 bg-slate-50/60">
                <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-20 lg:py-24 grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-8">
                        <div className="tr-overline mb-4">· Digital workflow</div>
                        <h1 className="font-display font-light text-5xl lg:text-7xl tracking-tight leading-[0.98] text-slate-900">
                            Frictionless onboarding,<br /><span className="italic">for busy clinics.</span>
                        </h1>
                    </div>
                    <div className="lg:col-span-4 self-end">
                        <p className="text-[15.5px] text-slate-600 leading-[1.75]">
                            Drop in your scan files, mark the teeth, choose a shade. We&rsquo;ll handle the rest —
                            from design and printing to dispatch.
                        </p>
                    </div>
                </div>
            </section>

            {/* 4-STEP INFOGRAPHIC */}
            <section className="max-w-[1280px] mx-auto px-5 lg:px-8 py-20 lg:py-24" data-testid="workflow-steps">
                <div className="grid lg:grid-cols-4 gap-4 lg:gap-5">
                    {STEPS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div key={s.n} className="tr-card p-7 relative overflow-hidden">
                                <div className="font-mono-tr text-[10.5px] tracking-[0.22em] uppercase text-cyan-700">{s.n}</div>
                                <div className="mt-4 h-12 w-12 rounded-xl bg-slate-100 flex items-center justify-center text-slate-700">
                                    <Icon size={22} />
                                </div>
                                <div className="mt-5 font-display text-2xl tracking-tight text-slate-900">{s.t}</div>
                                <p className="mt-2 text-[14px] text-slate-600 leading-relaxed">{s.d}</p>
                                {i < STEPS.length - 1 && (
                                    <div className="hidden lg:block absolute right-[-22px] top-12 z-10">
                                        <ArrowRight className="text-slate-300" size={20} />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </section>
        </>
    );
}
